export default "__VITE_ASSET__CzKSgQle__"